import React, { useEffect, useState } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableFooter,
	TableHead,
	TableRow,
	Paper,
	TextField,
	Button,
} from "@mui/material";
import "../../../css/empresa_uno/ventas.css";
import { ModalCompraMercaderia } from "../ModalCompraMercaderia";
import { ModalGastos } from "../ModalGastos";
import { ModalDetalleCaja } from "../ModalDetalleCaja";
import logoJhimbo from "../../../images/logo-jhimbo.png";
import GeneratePdfCajaInforme from "./../../../Reports/GeneratePdfCajaInforme";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { PDFDownloadLink } from "@react-pdf/renderer";
import pdf from "../../../images/pdf.png";
import { ApiService } from "../../ApiService";
import { useParams } from "react-router-dom";
import { useCompanyAssigned } from "../../CompanyAssignedContext";


export const Vcaja = ({ selectedSucursal, permisos, currentUserPermissions, convertPrice = (() => { }) }) => {
	const { nit, sub_direc } = useParams();
	const [selectedSection, setSelectedSection] = useState("caja"); // 'caja' o 'informe'

	const [sucursales, setSucursales] = useState(null);
	const [objCaja, setObjCaja] = useState([]);
	const [objProductos, setObjProductos] = useState([]);
	const [fechaCaja, setFechaCaja] = useState(null);

	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleOpenModal = () => {
		setIsModalOpen(true);
	};

	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	const [isModalOpenGastos, setIsModalOpenGastos] = useState(false);

	const handleOpenModalGastos = () => {
		setIsModalOpenGastos(true);
	};

	const handleCloseModalGastos = () => {
		setIsModalOpenGastos(false);
	};

	const [selectedRow, setSelectedRow] = useState(null); // Para guardar la fila seleccionada
	const [isModalDetalleOpen, setIsModalDetalleOpen] = useState(false);

	const handleRowClick = (row) => {
		setSelectedRow(row);
		setIsModalDetalleOpen(true);
	};

	const handleCloseModalDetalle = () => {
		setIsModalDetalleOpen(false);
		setSelectedRow(null);
	};

	const fech_querys = async (key_branch, fecha1) => {
		const url =
			fecha1 != null
				? `api/company/cash/list-date?param_date=${fecha1}&key_branch=${key_branch}`
				: `api/company/product/short-list?key_branch=${key_branch}&type=all`;

		const options = { method: "GET" };

		const request_caja = await ApiService.fetchData(url, options);

		if (!request_caja) {
			alert("Error al cargar los datos");
			return;
		}

		if (fecha1 != null) {
			setObjCaja(request_caja);
		} else {
			setObjProductos(request_caja);
		}
	};



	useEffect(() => {
		const current_suc = selectedSucursal;
		const comp_date = new Date();
		const currentDate = `${comp_date.getFullYear()}-${String(comp_date.getMonth() + 1).padStart(2, "0")}-${String(comp_date.getDate()).padStart(2, "0")}`;

		setSucursales(current_suc);

		if (fechaCaja == null) {
			setFechaCaja(currentDate);
		}

		fech_querys(current_suc, fechaCaja || currentDate);
		fech_querys(current_suc, null);
	}, [selectedSucursal]);

	function handleChange(e) {
		setFechaCaja(e);

		fech_querys(sucursales, e);
	}

	const totalPc =
		objCaja && objCaja.reduce((acc, row) => (parseFloat(acc) + parseFloat(row.purchase_price)).toFixed(2), 0);
	const totalB =
		objCaja &&
		objCaja.reduce(
			(acc, row) => (parseFloat(acc) + (parseFloat(row.price) - parseFloat(row.purchase_price))).toFixed(2),
			0
		);
	const totalGeneral =
		objCaja && objCaja.reduce((acc, row) => (parseFloat(acc) + parseFloat(row.price)).toFixed(2), 0);
	const totalEfectivoEntrada =
		objCaja &&
		objCaja.reduce(
			(acc, row) =>
				(parseFloat(acc) + (row.type == 1 && row.pay == "efectivo" ? parseFloat(row.price) : 0)).toFixed(2),
			0
		);
	const totalEfectivoSalida =
		objCaja &&
		objCaja.reduce(
			(acc, row) =>
				(parseFloat(acc) + (row.type != 1 && row.pay == "efectivo" ? parseFloat(row.price) : 0)).toFixed(2),
			0
		);
	const totalQrEntrada =
		objCaja &&
		objCaja.reduce(
			(acc, row) => (parseFloat(acc) + (row.type == 1 && row.pay == "qr" ? parseFloat(row.price) : 0)).toFixed(2),
			0
		);
	const totalQrSalida =
		objCaja &&
		objCaja.reduce(
			(acc, row) => (parseFloat(acc) + (row.type != 1 && row.pay == "qr" ? parseFloat(row.price) : 0)).toFixed(2),
			0
		);
	const totalDeboE =
		objCaja &&
		objCaja.reduce(
			(acc, row) =>
				(
					(row.pay == "en espera" ? parseFloat((row.type == 1 ? "" : "-") + row.price) : 0) + parseFloat(acc)
				).toFixed(2),
			0
		);
	// console.log("Mis permisos:", permisos);
	return (
		<div>
			<div className="functionality-container" style={{ paddingBottom: "5px" }}>
				<div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
					<div
						className="section-caja-informe"
						style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
						<div
							className="section-ci"
							onClick={() => setSelectedSection("caja")}
							style={{
								cursor: "pointer",
								borderBottom: selectedSection === "caja" ? `3px solid var(--theme-company)` : "none",
							}}>
							<span style={{ color: 'var(--theme-company)' }} >Caja</span>
						</div>
						{
							(permisos?.informe || permisos?.informe_cgc) && (
								<div
									className="section-ci"
									onClick={() => setSelectedSection("informe")}
									style={{
										cursor: "pointer",
										borderBottom: selectedSection === "informe" ? `3px solid var(--theme-company)` : "none",
									}}>
									<span style={{ color: 'var(--theme-company)' }}>Informe</span>
								</div>
							)
						}
					</div>

					<div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
						{permisos?.addMercaderia && (
							<button className="btn-azul-company" style={{ background: 'var(--theme-company)', borderColor: 'var(--theme-company)' }} onClick={handleOpenModal}>
								Compra de mercadería
							</button>
						)}

						{permisos?.addGastos && (
							<button className="btn-azul-company" style={{ background: 'var(--theme-company)', borderColor: 'var(--theme-company)' }} onClick={handleOpenModalGastos}>
								Gastos y otros
							</button>
						)}

						<TextField
							label="Fecha"
							type="date"
							value={fechaCaja}
							onChange={(e) => {
								handleChange(e.target.value);
							}}
							size="small"
							sx={{ width: "150px" }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
{/*FALTA */}
						<PDFDownloadLink
							document={<></>} 
							// document={<GeneratePdfCajaInforme convertPrice={convertPrice} />} 
							fileName="Caja.pdf"
							color={'var(--theme-company)'} //color para despues
						>
							{({ loading, url, error }) => (
								<Button
									variant="contained"
									href={url}            // enlace real que genera react-pdf
									download              // fuerza descarga
									// disabled={loading || !!error}
									disabled={true}
									startIcon={<PictureAsPdfIcon />}
									sx={{ height: 41, background: 'var(--theme-company)' }}   // lo que antes era style={{height:"41px"}}
								>
									{loading ? "Generando PDF…" : "PDF"}
								</Button>
							)}
						</PDFDownloadLink>
					</div>
					{isModalOpen && (
						<ModalCompraMercaderia //MEJORAR
							onClose={handleCloseModal}
							products={
								objProductos &&
								objProductos.map(({ code_product, fullName, key_product }) => ({
									code_product,
									fullName,
									key_product,
								}))
							}
							updated_list={() => {
								fech_querys(sucursales, fechaCaja);
							}}
							key_branch={sucursales}
							convertPrice={convertPrice}
						/>
					)}
					{isModalOpenGastos && (
						<ModalGastos //MEJORAR
							onClose={handleCloseModalGastos}
							updated_list={() => {
								fech_querys(sucursales, fechaCaja);
							}}
							key_branch={sucursales}
							convertPrice={convertPrice}
						/>
					)}
				</div>
			</div>

			<div style={{ marginTop: "20px" }}>
				{selectedSection === "caja" && (
					<div>
						<TableContainer component={Paper}>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell
											align="center"
											rowSpan={2}
											sx={{
												backgroundColor: 'var(--theme-company)',
												color: "#fff",
												fontWeight: "bold",
												fontSize: "0.8rem",
												py: 0.5,
												px: 1,
											}}>
											FECHA
										</TableCell>
										<TableCell
											align="center"
											rowSpan={2}
											sx={{
												backgroundColor: 'var(--theme-company)',
												color: "#fff",
												fontWeight: "bold",
												fontSize: "0.8rem",
												py: 0.5,
												px: 1,
											}}>
											CODIGO
										</TableCell>
										<TableCell
											align="center"
											rowSpan={2}
											sx={{
												backgroundColor: 'var(--theme-company)',
												color: "#fff",
												fontWeight: "bold",
												fontSize: "0.8rem",
												py: 0.5,
												px: 1,
											}}>
											DETALLE
										</TableCell>


										{!permisos?.remove_costo && (
											<TableCell
												align="center"
												rowSpan={2}
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.5,
													px: 1,
												}}>
												P.C.
											</TableCell>
										)}
										{!permisos?.remove_bene && (
											<TableCell
												align="center"
												rowSpan={2}
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.5,
													px: 1,
												}}>
												B
											</TableCell>
										)}
										<TableCell
											align="center"
											rowSpan={2}
											sx={{
												backgroundColor: 'var(--theme-company)',
												color: "#fff",
												fontWeight: "bold",
												fontSize: "0.8rem",
												py: 0.5,
												px: 1,
											}}>
											TOTAL
										</TableCell>
										<TableCell
											align="center"
											colSpan={2}
											sx={{
												backgroundColor: 'var(--theme-company)',
												color: "#fff",
												fontWeight: "bold",
												fontSize: "0.8rem",
												py: 0.5,
											}}>
											EFECTIVO
										</TableCell>
										<TableCell
											align="center"
											colSpan={2}
											sx={{
												backgroundColor: 'var(--theme-company)',
												color: "#fff",
												fontWeight: "bold",
												fontSize: "0.8rem",
												py: 0.5,
											}}>
											QR
										</TableCell>
										<TableCell
											align="center"
											rowSpan={2}
											sx={{
												backgroundColor: 'var(--theme-company)',
												color: "#fff",
												fontWeight: "bold",
												fontSize: "0.8rem",
												py: 0.5,
												px: 1,
											}}>
											DEBO/E
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell
											align="center"
											sx={{
												backgroundColor: 'var(--theme-company)',
												color: "#fff",
												fontWeight: "bold",
												fontSize: "0.8rem",
												py: 0.3,
												px: 1,
											}}>
											Entrada
										</TableCell>
										<TableCell
											align="center"
											sx={{
												backgroundColor: 'var(--theme-company)',
												color: "#fff",
												fontWeight: "bold",
												fontSize: "0.8rem",
												py: 0.3,
												px: 1,
											}}>
											Salida
										</TableCell>
										<TableCell
											align="center"
											sx={{
												backgroundColor: 'var(--theme-company)',
												color: "#fff",
												fontWeight: "bold",
												fontSize: "0.8rem",
												py: 0.3,
												px: 1,
											}}>
											Entrada
										</TableCell>
										<TableCell
											align="center"
											sx={{
												backgroundColor: 'var(--theme-company)',
												color: "#fff",
												fontWeight: "bold",
												fontSize: "0.8rem",
												py: 0.3,
												px: 1,
											}}>
											Salida
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{objCaja &&
										objCaja.map((row, index) => (
											<TableRow
												key={index}
												// onClick={() => row.pay === 'en espera' && handleRowClick(row)}
												onClick={() => handleRowClick(row)}
												style={{
													// cursor: row.pay === 'en espera' ? 'pointer' : 'default',
													cursor: "pointer",
												}}>
												<TableCell align="center">{row.date_ope}</TableCell>
												<TableCell align="center">{row.code}</TableCell>
												<TableCell align="center">{row.detail}</TableCell>
												{!permisos?.remove_costo && (
													<TableCell align="center">{row.purchase_price}</TableCell>
												)}
												{!permisos?.remove_bene && (
													<TableCell align="center">
														{(
															parseFloat(row.price) - parseFloat(row.purchase_price)
														).toFixed(2)}
													</TableCell>
												)}
												<TableCell align="center">{row.price}</TableCell>

												<TableCell align="center">
													{row.type == 1 && row.pay === "efectivo" ? row.price : 0}
												</TableCell>
												<TableCell align="center">
													{row.type != 1 && row.pay === "efectivo" ? row.price : 0}
												</TableCell>

												<TableCell align="center">
													{row.type == 1 && row.pay === "qr" ? row.price : 0}
												</TableCell>
												<TableCell align="center">
													{row.type != 1 && row.pay === "qr" ? row.price : 0}
												</TableCell>

												<TableCell
													align="center"
													style={{
														backgroundColor:
															row.pay === "en espera" ? "rgba(255, 0, 250, 0.2)" : "#fff",
													}}>
													{row.pay == "en espera"
														? row.type == 1
															? row.price
															: "-" + row.price
														: 0}
												</TableCell>
											</TableRow>
										))}
								</TableBody>

								{isModalDetalleOpen && (
									<ModalDetalleCaja
										isOpen={isModalDetalleOpen}
										onClose={handleCloseModalDetalle}
										rowData={selectedRow}
										updated_list={() => {
											fech_querys(sucursales, fechaCaja);
										}}
										key_branch={sucursales}
									/>
								)}

								<TableFooter>
									{/* FILA DE TOTALES */}
									<TableRow>
										<TableCell align="center" colSpan={3} style={{ fontWeight: "bold" }}>
											TOTAL
										</TableCell>
										{!permisos?.remove_costo && (
											<TableCell align="center" style={{ fontWeight: "bold" }}>
												{convertPrice(totalPc)}
											</TableCell>
										)}

										{!permisos?.remove_bene && (
											<TableCell align="center" style={{ fontWeight: "bold" }}>
												{convertPrice(totalB)}
											</TableCell>
										)}
										<TableCell align="center" style={{ fontWeight: "bold" }}>
											{convertPrice(totalGeneral)}
										</TableCell>
										<TableCell align="center" style={{ fontWeight: "bold" }}>
											{convertPrice(totalEfectivoEntrada)}
										</TableCell>
										<TableCell align="center" style={{ fontWeight: "bold" }}>
											{convertPrice(totalEfectivoSalida)}
										</TableCell>
										<TableCell align="center" style={{ fontWeight: "bold" }}>
											{convertPrice(totalQrEntrada)}
										</TableCell>
										<TableCell align="center" style={{ fontWeight: "bold" }}>
											{convertPrice(totalQrSalida)}
										</TableCell>
										<TableCell align="center" style={{ fontWeight: "bold" }}>
											{convertPrice(totalDeboE)}
										</TableCell>
									</TableRow>
									{/* FILA TOTAL EFECTIVO Y TOTAL QR */}
									<TableRow>
										<TableCell colSpan={permisos?.remove_costo && permisos?.remove_bene ? 4 : 6} style={{ backgroundColor: 'var(--theme-company)' }} />
										<TableCell
											colSpan={2}
											align="center"
											style={{
												fontWeight: "bold",
												backgroundColor: 'var(--theme-company)',
												color: "#fff",
												paddingRight: "1rem",
											}}>
											Total Ef: {convertPrice(totalEfectivoEntrada - totalEfectivoSalida)}
										</TableCell>

										<TableCell
											colSpan={2}
											align="center"
											style={{
												fontWeight: "bold",
												backgroundColor: 'var(--theme-company)',
												color: "#fff",
												paddingLeft: "1rem",
											}}>
											Total Qr: {convertPrice(totalQrEntrada - totalQrSalida)}
										</TableCell>
										<TableCell style={{ backgroundColor: 'var(--theme-company)' }} />
									</TableRow>
								</TableFooter>
							</Table>
						</TableContainer>
					</div>
				)}
				{selectedSection === "informe" && (
					<div className="content-informe">
						<div className="header-informe">
							<div style={{ lineHeight: "1.3" }}>
								<img src={logoJhimbo} alt="logo" />
								<div>
									<p>Empresa Importadora Maquinarias y Herramientas</p>
									<p>Dirección: 2do y 3er anillo Av. Virgen de Cotoca</p>
									<div style={{ display: "flex", flexDirection: "row", gap: "2rem" }}>
										<p>Nit: 11310247012</p>
										<p>Tel: 67855168</p>
									</div>
								</div>
							</div>

							<div style={{ position: "relative", right: "25px" }}>
								<h2 style={{ fontWeight: "600" }}>INFORME DE CAJA</h2>
							</div>

							<div style={{ position: "relative", right: "25px" }}>
								<h3>N°1</h3>
							</div>
						</div>

						<div className="dealer-caja">
							<div style={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
								<p>Caja: FERNANDO MENDOZA MAMANI</p>
								<p>Tel: 65487562</p>
							</div>
							<p>Fecha: 20/10/2024</p>
						</div>

						<div className="tabla-informe-container">
							<table className="tabla-informe-detalles">
								<thead>
									<tr>
										<th style={{ background: 'var(--theme-company)' }} className="tabla-informe-header">DETALLES</th>
										<th style={{ background: 'var(--theme-company)' }} className="tabla-informe-header">SALDO ANTERIOR</th>
										<th style={{ background: 'var(--theme-company)' }} className="tabla-informe-header">BOLIVIANOS</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td className="tabla-informe-cell red-text">Ventas Netas</td>
										<td className="tabla-informe-cell red-text">20000</td>
										<td className="tabla-informe-cell red-text">20000</td>
									</tr>
									<tr>
										<td className="tabla-informe-cell pink-text">Costo de mercadería</td>
										<td className="tabla-informe-cell pink-text">200</td>
										<td className="tabla-informe-cell pink-text">0</td>
									</tr>
									<tr>
										<td className="tabla-informe-cell pink-text">Mercadería por Pagar</td>
										<td className="tabla-informe-cell pink-text">5000</td>
										<td className="tabla-informe-cell pink-text">5000</td>
									</tr>
									<tr>
										<td className="tabla-informe-cell pink-text">Gastos Varios</td>
										<td className="tabla-informe-cell pink-text">200</td>
										<td className="tabla-informe-cell pink-text">200</td>
									</tr>
									{permisos?.informe && (
										<tr>
											<td className="tabla-informe-cell orange-text">Capital en Dinero</td>
											<td className="tabla-informe-cell orange-text">13000</td>
											<td className="tabla-informe-cell orange-text">28000</td>
										</tr>
									)}
									{permisos?.informe && (
										<tr>
											<td className="tabla-informe-cell orange-text">Ganancia</td>
											<td className="tabla-informe-cell orange-text">5000</td>
											<td className="tabla-informe-cell orange-text">5000</td>
										</tr>
									)}
									<tr>
										<td className="tabla-informe-cell">Cuentas por Cobrar</td>
										<td className="tabla-informe-cell">200</td>
										<td className="tabla-informe-cell">200</td>
									</tr>
									<tr>
										<td className="tabla-informe-cell blue-text">Caja disponible</td>
										<td className="tabla-informe-cell blue-text">16800</td>
										<td className="tabla-informe-cell blue-text">32600</td>
									</tr>
									<tr>
										<td className="tabla-informe-cell green-text">Total Caja</td>
										<td className="tabla-informe-cell green-text">17800</td>
										<td className="tabla-informe-cell green-text">37600</td>
									</tr>
									<tr>
										<td className="tabla-informe-cell green-text">Efectivo</td>
										<td className="tabla-informe-cell green-text">17000</td>
										<td className="tabla-informe-cell green-text">30000</td>
									</tr>
									<tr>
										<td className="tabla-informe-cell green-text">QR</td>
										<td className="tabla-informe-cell green-text">800</td>
										<td className="tabla-informe-cell green-text">7600</td>
									</tr>
									{permisos?.informe && (
										<tr>
											<td className="tabla-informe-cell">Capital en mercadería</td>
											<td className="tabla-informe-cell">370000</td>
											<td className="tabla-informe-cell">342000</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>

						<div style={{ paddingRight: "30px", paddingLeft: "30px" }}>
							<TableContainer component={Paper}>
								<Table size="small">
									<TableHead>
										<TableRow>
											<TableCell
												align="center"
												rowSpan={2}
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.5,
													px: 1,
												}}>
												FECHA
											</TableCell>
											<TableCell
												align="center"
												rowSpan={2}
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.5,
													px: 1,
												}}>
												CODIGO
											</TableCell>
											<TableCell
												align="center"
												rowSpan={2}
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.5,
													px: 1,
												}}>
												DETALLE
											</TableCell>
											<TableCell
												align="center"
												rowSpan={2}
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.5,
													px: 1,
												}}>
												P.C.
											</TableCell>
											<TableCell
												align="center"
												rowSpan={2}
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.5,
													px: 1,
												}}>
												B
											</TableCell>
											<TableCell
												align="center"
												rowSpan={2}
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.5,
													px: 1,
												}}>
												TOTAL
											</TableCell>
											<TableCell
												align="center"
												colSpan={2}
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.5,
												}}>
												EFECTIVO
											</TableCell>
											<TableCell
												align="center"
												colSpan={2}
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.5,
												}}>
												QR
											</TableCell>
											<TableCell
												align="center"
												rowSpan={2}
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.5,
													px: 1,
												}}>
												DEBO/E
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												align="center"
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.3,
													px: 1,
												}}>
												Entrada
											</TableCell>
											<TableCell
												align="center"
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.3,
													px: 1,
												}}>
												Salida
											</TableCell>
											<TableCell
												align="center"
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.3,
													px: 1,
												}}>
												Entrada
											</TableCell>
											<TableCell
												align="center"
												sx={{
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													fontWeight: "bold",
													fontSize: "0.8rem",
													py: 0.3,
													px: 1,
												}}>
												Salida
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{objCaja &&
											objCaja.map((row, index) => (
												<TableRow
													key={index}
													// onClick={() => row.pay === 'en espera' && handleRowClick(row)}
													onClick={() => handleRowClick(row)}
													style={{
														// cursor: row.pay === 'en espera' ? 'pointer' : 'default',
														cursor: "pointer",
													}}>
													<TableCell align="center">{row.date_ope}</TableCell>
													<TableCell align="center">{row.code}</TableCell>
													<TableCell align="center">{row.detail}</TableCell>
													<TableCell align="center">{row.purchase_price}</TableCell>
													<TableCell align="center">
														{(
															parseFloat(row.price) - parseFloat(row.purchase_price)
														).toFixed(2)}
													</TableCell>
													<TableCell align="center">{row.price}</TableCell>
													<TableCell align="center">
														{row.type == 1 && row.pay === "efectivo" ? row.price : 0}
													</TableCell>
													<TableCell align="center">
														{row.type == 0 && row.pay === "efectivo" ? row.price : 0}
													</TableCell>
													<TableCell align="center">
														{row.type == 1 && row.pay === "qr" ? row.price : 0}
													</TableCell>
													<TableCell align="center">
														{row.type == 0 && row.pay === "qr" ? row.price : 0}
													</TableCell>
													<TableCell
														align="center"
														style={{
															backgroundColor:
																row.pay === "en espera"
																	? "rgba(255, 0, 250, 0.2)"
																	: "#fff",
														}}>
														{row.type == 1 ? row.price : "-" + row.price}
													</TableCell>
												</TableRow>
											))}
									</TableBody>

									{isModalDetalleOpen && (
										<ModalDetalleCaja
											isOpen={isModalDetalleOpen}
											onClose={handleCloseModalDetalle}
											rowData={selectedRow}
											updated_list={() => {
												fech_querys(sucursales, fechaCaja);
											}}
											key_branch={sucursales}
										/>
									)}

									<TableFooter>
										{/* FILA DE TOTALES */}
										<TableRow>
											<TableCell align="center" colSpan={3} style={{ fontWeight: "bold" }}>
												TOTAL
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold" }}>
												{convertPrice(totalPc)}
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold" }}>
												{convertPrice(totalB)}
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold" }}>
												{convertPrice(totalGeneral)}
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold" }}>
												{convertPrice(totalEfectivoEntrada)}
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold" }}>
												{convertPrice(totalEfectivoSalida)}
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold" }}>
												{convertPrice(totalQrEntrada)}
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold" }}>
												{convertPrice(totalQrSalida)}
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold" }}>
												{convertPrice(totalDeboE)}
											</TableCell>
										</TableRow>
										{/* FILA TOTAL EFECTIVO Y TOTAL QR */}
										<TableRow>
											<TableCell colSpan={6} style={{ backgroundColor: 'var(--theme-company)' }} />
											<TableCell
												colSpan={2}
												align="center"
												style={{
													fontWeight: "bold",
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													paddingRight: "1rem",
												}}>
												Total Ef: {convertPrice(totalEfectivoEntrada - totalEfectivoSalida)}
											</TableCell>

											<TableCell
												colSpan={2}
												align="center"
												style={{
													fontWeight: "bold",
													backgroundColor: 'var(--theme-company)',
													color: "#fff",
													paddingLeft: "1rem",
												}}>
												Total Qr: {convertPrice(totalQrEntrada - totalQrSalida)}
											</TableCell>
											<TableCell style={{ backgroundColor: 'var(--theme-company)' }} />
										</TableRow>
									</TableFooter>
								</Table>
							</TableContainer>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
